export default __webpack_public_path__ + "static/media/roof.min.89a7670b.png";